import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://wfdyohgvsrxrhhvmvvfb.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndmZHlvaGd2c3J4cmhodm12dmZiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgwMDgwNDIsImV4cCI6MjA5MzU4NDA0Mn0.kniPGeJg-7wPSgqYFbY5BCfBBfujwV4aRhq0MqXlHYQ';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
